import React from "react";

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  handleRefresh = () => {
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen w-full flex items-center justify-center px-6 py-12 text-slate-900"
          style={{
            background:
              "radial-gradient(1200px 800px at 20% -10%, rgba(46, 134, 255, 0.18), rgba(46, 134, 255, 0) 60%), radial-gradient(1000px 700px at 110% 10%, rgba(255, 119, 76, 0.18), rgba(255, 119, 76, 0) 55%), linear-gradient(180deg, #f6f8fb 0%, #eef2f7 100%)",
          }}
        >
          <div className="w-full max-w-2xl rounded-3xl bg-white px-10 py-12 text-center shadow-[0_24px_60px_rgba(15,23,42,0.16),0_6px_16px_rgba(15,23,42,0.08)]">
            <div className="mx-auto mb-4 inline-flex items-center justify-center rounded-full bg-rose-50 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-rose-700">
              Error
            </div>
            <h1 className="font-semibold! text-slate-900! leading-tight! normal-case! text-6xl!">
              Oops!
            </h1>
            <div className="mt-2!">
              <span className="text-2xl! ">
                Something went wrong, <br /> please refresh the page!
              </span>
            </div>
            <button className="btn btn-primary mx-auto mt-6! w-28" onClick={this.handleRefresh}>
              Refresh
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
